import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=24358dfb&"
import script from "./Billing.vue?vue&type=script&lang=js&"
export * from "./Billing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports